import {BizFileFileInfo} from "./biz-file-file-info";

export type InMemoryBizFileUrlChannel = "bizFile" | "ncrBizForm" | "operatorBizForm";

const store: Record<InMemoryBizFileUrlChannel, BizFileFileInfo | null> = {
    bizFile: null,
    ncrBizForm: null,
    operatorBizForm: null,
};

export function setInMemoryBizFileUrlInfo(channel: InMemoryBizFileUrlChannel, info: BizFileFileInfo | null): void {
    store[channel] = info;
}

export function getInMemoryBizFileUrlInfo(channel: InMemoryBizFileUrlChannel): BizFileFileInfo | null {
    return store[channel];
}

/**
 * Maps {@code CreateBizFileAccessToken} response data to {@link BizFileFileInfo}.
 * Token is stored with the same {@code ?} prefix convention used when concatenating preview URLs.
 */
export function bizFileAccessTokenResponseToFileInfo(data: { baseURL?: string; token?: string } | null | undefined): BizFileFileInfo | null {
    if (!data?.baseURL) {
        return null;
    }
    return {
        baseUrl: data.baseURL,
        token: data.token ? `?${data.token}` : "",
    };
}
